import React, { Component } from 'react';
import _ from "lodash";
import moment from "moment";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import TextAutocompleteInput from "./TextAutocompleteInput";
import Header from "./Header";



class Admin extends Component {

  state={
    newMovie: {
      english_title: "",
      original_title: "",
      poster: "",
    },
    newEntry: {
      distributor: "",
      local_title: "",
      release_date: "",
      country: "",
    },
    untitled_movies_edit: {},
    disconnectedMovies: [],
  };
  createMovie = () => {
    const { original_title, english_title, poster } = this.state.newMovie;
    this.props.createMovie(original_title, english_title, poster );
    this.setState({ newMovie: { original_title: "", english_title: "", poster: "" } })
  };

  createEntry = () => {
    const { local_title, distributor, release_date, country } = this.state.newEntry;
    this.props.createMovieEntry("untitledmovieentries", local_title, distributor, release_date, country );
    this.setState({ newEntry: { local_title: "", distributor: "", release_date: "", country: "" } })
  };

  attributeMovieToEntry = (entry_id) => {
    const movie_id = this.state.untitled_movies_edit[entry_id];
    this.props.attributeMovieToEntry(entry_id, movie_id, "untitledmovieentries");
  };

  deleteMovieEntry = (entry_id, name, country) => {
    const msg = `Want to delete movie entry for ${name} in the country ${country} ?`;
    this.props.deleteItem(entry_id,msg, "untitledmovieentries");
  };

  changeNewMovie = (name, value) => {
    this.setState( ({newMovie}) => {
      newMovie[name] = value;
      return newMovie;
    });
  };

  changeNewEntry = (name, value) => {
    this.setState( ({newEntry}) => {
      newEntry[name] = value;
      return newEntry;
    });
  };

  changeUntitledMovie = (v,id) => {
    this.setState( ({untitled_movies_edit}) => {
      untitled_movies_edit[id] = v;
      return untitled_movies_edit;
    });
  };

  static getDerivedStateFromProps(props,state) {
    console.log("derived state from props")
    if(Object.keys(props.movies).length > 0 && props.movies["untitledmovieentries"] && props.movies["untitledmovieentries"].movie_entries.length !== state.disconnectedMovies.length){
      console.log("update untitles");
      return {disconnectedMovies: props.movies["untitledmovieentries"].movie_entries.sort( (a,b) => a.release_date > b.release_date ? 1 : -1)};
    }
    return {};
  }

  componentDidMount() {
    this.props.getItems();
    this.props.getAdminItems();
    this.props.getInvalidEntries();
  }


  render() {
    console.log(this.props.movies)
    if(!this.props.authed){
      return <Redirect to="/" />
    }
    if(Object.keys(this.props.movies).length === 0 ){
      return ( 
        <div className="page">
          <Header authed={this.props.authed}  homepageShowAllToggle={this.props.homepageShowAllToggle} homepageShowAll={this.props.homepageShowAll} logout={this.props.logout}/>
          <Link className="header__back" to="/">
            <FontAwesomeIcon icon="chevron-left" />
            <div>Back</div>
          </Link>
          <p>loading</p>
        </div>
      );
    }
    const movie_list= this.state.disconnectedMovies.slice(0,20);

    return (
      <div className="admin">
        <Header authed={this.props.authed}  homepageShowAllToggle={this.props.homepageShowAllToggle} homepageShowAll={this.props.homepageShowAll} logout={this.props.logout} setRedirect={this.props.setRedirect}/>
        <div className="page__content">
          <Link className="header__back" to="/">Back</Link>
          <div className="new-movie">
            <div className="new-movie__header" >New Movie</div>
            <div className={"new-movie__form "}>
              <input placeholder="English Title" type="text" value={this.state.newMovie.english_title} onChange={ (e) => this.changeNewMovie("english_title",e.target.value) }/>
              <input placeholder="Original Title" value={this.state.newMovie.original_title} onChange={ (e) => this.changeNewMovie("original_title",e.target.value) }/>
              <input placeholder="Poster" value={this.state.newMovie.poster} onChange={ (e) => this.changeNewMovie("poster",e.target.value) }/>
              <button className="new-movie__button button" onClick={this.createMovie}>New Movie</button>
            </div>
          </div>
          <div className="new-movie">
            <div className="new-movie__header" >New Movie Entry</div>
            <div className={"new-movie__form "}>
              <input placeholder="Distributor" type="text" value={this.state.newEntry.distributor} onChange={ (e) => this.changeNewEntry("distributor",e.target.value) }/>
              <input placeholder="Local Title" value={this.state.newEntry.local_title} onChange={ (e) => this.changeNewEntry("local_title",e.target.value) }/>
              <input placeholder="Release Date (YYYY-MM-DD)" value={this.state.newEntry.release_date} onChange={ (e) => this.changeNewEntry("release_date",e.target.value) }/>
              <input placeholder="Country" value={this.state.newEntry.country} onChange={ (e) => this.changeNewEntry("country",e.target.value) }/>
              <button className="new-movie__button button" onClick={this.createEntry}>New Movie Entry</button>
            </div>
          </div>
          <div>
            <div> Unconnected Movies </div>
            <div className="admin__movies">
              {movie_list.map( movie_entry => {
                
                const {entry_id, country, local_title, distributor, release_date, source_url} = movie_entry;
                const editValue = this.state.untitled_movies_edit[movie_entry.entry_id]; 
                return (
                  <div className="admin__movies__item" key={entry_id}>
                    <a target="_blank" href={source_url}>Link</a>
                    <div>{country}</div>
                    <div>{local_title}</div>
                    <div>{distributor}</div>
                    <div>{release_date}</div>
                    <TextAutocompleteInput 
                      placeholder="movie"
                      itemValue={ (item) => item.movie_id }
                      itemLabel={ (item) => item.english_title }
                      itemKey={ (item) => item.movie_id }
                      value={editValue}
                      items={Object.values(this.props.movies).filter(o => _.includes(_.lowerCase(o.english_title), _.lowerCase(editValue) ) )}
                      onChange={(v) => this.changeUntitledMovie(v,movie_entry.entry_id)}
                      onSelect={(v) => this.changeUntitledMovie(v,movie_entry.entry_id)}
                      inputHeight="35px"
                    />
                    <div className="button" onClick={() => this.attributeMovieToEntry(movie_entry.entry_id)}>Save</div>
                    <div className="button" onClick={() => this.deleteMovieEntry(movie_entry.entry_id, local_title, country)} >Delete</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/components/Admin.js